module.exports = __webpack_public_path__ + "img/pinjietu.d8d85d8a.png";